export default __webpack_public_path__ + "static/media/reports.c846f09e.svg";